import React, { Component } from 'react';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';


export default class Contact extends Component { 
  state = { 
  }
  
  render () {                                   
      return (
        <React.Fragment>
              <Header />
                    
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdqonGvmqBLFTttPA4auK9V4RiSOrSa98oxGG6DfhgzMOWe-w/viewform?embedded=true" width="1000" height="600" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>

              <Footer />
         </React.Fragment>
      )
   }
}



